module.exports = __webpack_public_path__ + "media/images/home/feature/staff_timestamp-0d0317203e143f224bf6e895d1f22908.png";